// extracted by mini-css-extract-plugin
export default {"highlighted":"Advantage_highlighted__DhBhM","smallHeading":"Advantage_smallHeading__ReOII","advStatus":"Advantage_advStatus__lbuEO","enrolled":"Advantage_enrolled__EcmXo"};